/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import RootApp from './root-app';

export default RootApp;



// WEBPACK FOOTER //
// ./src/containers/RootApp/index.js